var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-date-picker',_vm._g(_vm._b({attrs:{"value":_vm.value,"placeholder":_vm.placeholder,"value-format":_vm.finalValueFormat},on:{"change":_vm.onChange}},'el-date-picker',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }